import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, take, takeUntil } from "rxjs";
import { UserpilotReloader } from "../../../helper/userpilot-reloader.component";
import { SectionFormService } from "../../project-info/checklist/checklist-form/checklist-section-form.service";
import { ProjectChecklistService } from "../../project-info/checklist/checklist.service";

@Component({
  selector: 'app-template-create',
  templateUrl: './project-input-template-create.component.html',
  styleUrls: [
    './project-input-template-create.component.scss',
  ],
})
export class ProjectInputTemplateCreateComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new Subject<void>();
  editingChecklist = false;

  constructor(
    public checklistService: ProjectChecklistService,
    private sectionFormService: SectionFormService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.router.events
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(event => {
        if (this.router.url.includes('/create-template/edit/') || this.router.url.includes('/create-template/new')) {
          this.editingChecklist = true;
        } else {
          this.editingChecklist = false;
        }
      });

    if (this.router.url.includes('/create-template/new')) {
      this.editingChecklist = true;
    }
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next();
    this.onDestroyNotifier.complete();
  }

  saveTemplate() {
    if (['form', 'tabs'].includes(this.checklistService.projectInfo.checklists[0]?.displayMethod)) {
      this.checklistService.formSavedToChecklistNotifier.pipe(take(1)).subscribe(saved => {
        if (saved) this.checklistService.onSaveFormTemplate();
      });
      this.sectionFormService.saveFormToChecklist();
      this.checklistService.checklistFormTemplatesUpdatedNotifier.pipe(take(1)).subscribe(() => {
        this.cancelTemplate();
      });
    }
  }

  cancelTemplate() {
    this.router.navigate(['.'], { relativeTo: this.route.parent });
    this.checklistService.projectInfo.checklists = [];
  }
}